import { render } from "./sysDataUpdateList.vue?vue&type=template&id=97fc8a02"
import script from "./sysDataUpdateList.vue?vue&type=script&lang=js"
export * from "./sysDataUpdateList.vue?vue&type=script&lang=js"

import "./sysDataUpdateList.vue?vue&type=style&index=0&id=97fc8a02&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__